import script from "./UploadStatusProgressBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadStatusProgressBar.vue?vue&type=script&setup=true&lang=ts"

import "./UploadStatusProgressBar.vue?vue&type=style&index=0&id=579220fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-579220fd"]])

export default __exports__